import { Color } from '@diritto/common/style/color';
import { twMerge } from 'tailwind-merge';

export const AdultBoxIcon = ({ className, color = Color.Gray500 }: { className?: string; color?: string }) => (
  <svg
    className={twMerge('size-[16px]', className)}
    width="100%"
    height="100%"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect width="16" height="16" rx="2" fill={color} />
    <path
      d="M6.21106 4.30087H5.0141L3.30005 5.47022V6.6698L4.91834 5.5811H4.95665V11.5992H6.21106V4.30087Z"
      fill="white"
    />
    <path
      d="M9.96512 4.20007C8.42822 4.18999 7.40841 5.27365 7.40841 6.70004C7.4132 8.08108 8.37077 9.07401 9.61082 9.06897C10.3721 9.07401 11.0424 8.69599 11.3919 8.06092H11.4685C11.4589 9.62844 10.894 10.5609 9.88852 10.5609C9.26131 10.5609 8.83519 10.193 8.71071 9.61332H7.47544C7.62865 10.823 8.55271 11.7 9.88852 11.7C11.593 11.7 12.675 10.2434 12.675 7.72826C12.6703 5.06195 11.3201 4.21015 9.96512 4.20007ZM8.62452 6.6698C8.61495 5.88856 9.19428 5.26356 9.9747 5.25852C10.7503 5.26356 11.3153 5.9188 11.3153 6.65972C11.3201 7.41576 10.7264 8.071 9.95555 8.071C9.17992 8.071 8.62452 7.45608 8.62452 6.6698Z"
      fill="white"
    />
  </svg>
);
